import Dashboard from './Dashboard';
import Login from './Login/Login';
import Page404 from './Page404';
import Page500 from './Page500';
import Register from './Register/Register';
import Email from './Password/Email';
import Password from './Password/Password';
import Reports from './Reports/Reports.js';

export {
  Page404,
  Page500,
  Register,
  Login,
  Dashboard,
  Email,
  Reports,
  Password
};



// WEBPACK FOOTER //
// ./src/views/index.js